import type { FC } from 'react';
import { useRef, useState } from 'react';
import { useResizeDetector } from '@mwl/core-lib';
import ArrowDownIcon from '@public/assets/common/icons/arrowDownRound.svg';
import { ButtonIcon } from '@/components/ButtonIcon/ButtonIcon';
import type { SpoilerProps } from '@/components/Spoiler/Spoiler.types';
import styles from './Spoiler.module.scss';
export const Spoiler: FC<SpoilerProps> = ({
  className,
  children,
  maxHeight = 100,
  initialState = false
}) => {
  const [show, setShowState] = useState(initialState);
  const contentRef = useRef<HTMLDivElement>(null);
  const {
    height
  } = useResizeDetector({
    targetRef: contentRef,
    onResize: () => undefined
  });
  const spoiler = maxHeight < (height ?? 0);
  return <div className={cn(styles.root, className, {
    [styles.show]: show,
    [styles.hasSpoiler]: spoiler
  })} data-sentry-component="Spoiler" data-sentry-source-file="Spoiler.tsx">
      <div className={styles.content} style={{
      maxHeight: !show ? maxHeight : height || undefined
    }}>
        <div ref={contentRef}>{children}</div>
      </div>
      {spoiler && <ButtonIcon className={styles.control} as="button" size="xs" onClick={() => setShowState(opened => !opened)} aria-label="spoiler toggle">
          <ArrowDownIcon className={styles.arrowIcon} />
        </ButtonIcon>}
    </div>;
};